import script from "./model-form-drawer.vue?vue&type=script&lang=ts&setup=true"
export * from "./model-form-drawer.vue?vue&type=script&lang=ts&setup=true"

import "./model-form-drawer.vue?vue&type=style&index=0&id=65c42a50&lang=scss&scoped=true"

import exportComponent from "D:\\Projects\\WebStorm\\operation-platform\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-65c42a50"]])

export default __exports__